<template>
  <div class="c-sc">
    <div v-if="addTitle" class="c-cover-title">{{ title }}</div>
    <div class="c-flex c c-cover-all" :class="center ? 'jc' : 'js'">
      <div class="c-cover-img" :class="`c-cover-${camera ? '160' : '80'}`">
        <label v-ripple>
          <c-img :src="cover" @click="openSelectCover" />
        </label>
      </div>
      <div v-if="camera" class="c-camera">
        <v-icon size="60" color="clr-camera" class="c-hand" @click="openSelectCover">mdi-camera</v-icon>
      </div>
      <div class="c-cover-btn" v-if="btnType == 'default'">
        <v-btn :disabled="disabled" color="clr-secondary" outline small @click="openSelectCover">{{
          $T('button.modify')
        }}</v-btn>
      </div>
    </div>

    <select-cover-dialog
      v-if="coverDialog"
      :srcImgs="covers"
      :selectedPath="path"
      :deletedSrcImgs="deletedCovers"
      :maxOriginalCount="count"
      @delete="onDeleteCover"
      @cancel="onCloseDialog"
      @ok="onCoverSelected"
    />

    <community-list-dialog
      ref="community_list_dialog"
      :dialogTitle="$T('common.cover.inuse.title')"
      :dialogMessage="$T('common.cover.inuse.message')"
      @cancel="onDeleteCoverCancel"
      @ok="onDeleteCoverOk"
    />

    <msg-dialog ref="msg_dialog" />
  </div>
</template>

<script>
import UTILS from '../../utils/utils';
import { getCovers } from '../../api/member';
import { checkCoverUsage } from '../../api/cover';
import { getCommunityDefaultCovers, getCommunityCovers } from '../../api/community';
import selectCoverDialog from './SelectCoverDialog.vue';
import communityListDialog from './CommunityListDialog.vue';

export default {
  components: {
    'select-cover-dialog': selectCoverDialog,
    'community-list-dialog': communityListDialog,
  },
  props: {
    type: { type: String, required: false, default: 'profile' },
    cid: { type: Number, required: false, default: -1 },
    coverPath: { type: String, required: false, default: null },
    addTitle: { type: Boolean, required: false, default: true },
    disabled: { type: Boolean, required: false, default: false },
    center: { type: Boolean, required: false, default: false },
    btnType: { type: String, required: false, default: 'default' },
  },
  watch: {
    coverPath(newVal, oldVal) {
      this.path = newVal;
      this.cover = newVal;
    },
    cid(newVal, oldVal) {
      if (newVal != oldVal) {
        this.covers = null;
      }
    },
  },
  data() {
    return {
      path: this.coverPath,
      cover: this.coverPath,
      covers: null,
      coversDefault: null,
      coverDialog: false,
      newCovers: null,
      deletedCovers: null,
    };
  },
  computed: {
    code() {
      switch (this.type) {
        case 'profile':
          return 1;
        case 'community':
          return 2;
      }
      throw new Exception('Unknown type' + this.type);
    },
    title() {
      if (this.code == 1) return $T('attributes.profile_cover');
      if (this.code == 2) return $T('attributes.community_cover');
    },
    count() {
      if (this.code == 1) return 10;
      if (this.code == 2) {
        return this.cid == 0 || this.cid == this.$store.state.community.fcid ? 2 : 5;
      }
    },
    camera() {
      return this.btnType == 'camera';
    },
    isChanged() {
      var n = this.newCovers;
      var d = this.deletedCovers;
      return this.coverPath != this.cover || (n && n.length > 0) || (d && d.length > 0);
    },
  },
  methods: {
    setPath(path) {
      this.path = path;
      this.cover = path;
    },
    resetPath(path) {
      this.setPath(path);
      this.covers = null;
      this.coversDefault = null;
      this.coverDialog = false;
      this.newCovers = null;
      this.deletedCovers = null;
    },
    openSelectCover() {
      if (this.disabled) return;
      if (this.code == 1) {
        this.openSelectProfileCover();
      } else {
        this.openSelectCommunityCover();
      }
    },
    openSelectCommunityCover() {
      if (this.covers) {
        this.coverDialog = true;
        return;
      }

      var _this = this;
      UTILS.startLoading();
      if (this.cid == -1) {
        getCommunityDefaultCovers()
          .then(function(response) {
            UTILS.stopLoading();
            _this.covers = response;
            _this.coversDefault = response;
            _this.coverDialog = true;
          })
          .catch(function(error) {
            UTILS.stopLoading();
            console.error('failed to get cover data', error);
          });
      } else {
        getCommunityCovers(this.cid)
          .then(function(response) {
            UTILS.stopLoading();
            _this.covers = response;
            _this.coverDialog = true;
          })
          .catch(function(error) {
            UTILS.stopLoading();
            console.error('failed to get cover data', error);
          });
      }
    },
    openSelectProfileCover() {
      if (this.covers) {
        this.coverDialog = true;
        return;
      }

      var _this = this;
      UTILS.startLoading();
      getCovers()
        .then(function(response) {
          UTILS.stopLoading();
          _this.covers = response;
          _this.coversDefault = response;
          _this.coverDialog = true;
        })
        .catch(function(error) {
          UTILS.stopLoading();
          console.error('failed to get cover data', error);
        });
    },
    onCoverSelected(newImgs, selectedImg, deletedImgs) {
      this.newCovers = newImgs;
      this.path = selectedImg;
      this.deletedCovers = deletedImgs;
      this.coverDialog = false;

      this.covers = [].concat(newImgs).concat(this.coversDefault);

      if (!selectedImg.startsWith('n-')) {
        this.cover = selectedImg;
        this.$emit('onCoverSelected', this);
        return;
      }

      for (var idx in newImgs) {
        var newImg = newImgs[idx];
        if (newImg.id == selectedImg) {
          this.cover = newImg.src;
          this.$emit('onCoverSelected', this);
          return;
        }
      }
      console.warn('there is no image for ' + selectedImg);
    },
    onDeleteCover(dialog, imgs, id) {
      if (this.type == 'profile') {
        this.onDeleteProfileCover(dialog, imgs, id);
      } else {
        this.onDeleteCommunityCover(dialog, imgs, id);
      }
    },
    onDeleteCommunityCover(dialog, imgs, id) {
      return dialog.deleteImg(id);
    },
    onDeleteProfileCover(dialog, imgs, id) {
      var _this = this;
      checkCoverUsage(id)
        .then(function(response) {
          if (response.profile) {
            _this.$refs.msg_dialog.open(
              $T('common.profile.cannot.delete.title'),
              $T('common.profile.cannot.delete.msg')
            );
            return dialog.cancelDeleteImg(id);
          }
          var communities = response.communities;
          if (!communities || communities.length == 0) {
            return dialog.deleteImg(id);
          }

          _this.$refs.community_list_dialog.open(communities, {
            dialog: dialog,
            id: id,
          });
        })
        .catch(function(error) {
          UTILS.stopLoading();
          console.error('failed to check cover data for [' + id + ']', error);
        });
    },
    onDeleteCoverOk(confirmValue) {
      var dialog = confirmValue.dialog;
      var id = confirmValue.id;
      dialog.deleteImg(id);
    },
    onDeleteCoverCancel(confirmValue) {
      var dialog = confirmValue.dialog;
      var id = confirmValue.id;
      dialog.cancelDeleteImg(id);
    },
    onCloseDialog() {
      this.coverDialog = false;
    },
    appendNewCoversToForm(form, key) {
      for (var i in this.newCovers) {
        var newImg = this.newCovers[i];
        form.append(key + '[' + i + ']', this.$imageUtils.dataUrlToBlob(newImg.src, 'image/jpeg'), newImg.id);
      }
    },
    appendDeletedCoversToForm(form, key) {
      if (this.hasDeletedCovers()) {
        form.append(key, this.deletedCovers);
      }
    },
    hasDeletedCovers() {
      return this.deletedCovers != null && this.deletedCovers.length > 0;
    },
  },
};
</script>

<style scoped>
.c-sc {
  position: relative;
  margin: 0 auto;
}
.c-err-msg {
  margin: 10px 0px 5px 0px;
  font-size: 18px;
}
.c-prof {
  margin: 20px auto 25px auto;
  width: 75%;
}
.c-prof-name {
  margin-top: 24px;
}
.c-cover-btn {
  margin-left: 10px;
}
.c-cover-title {
  margin-bottom: 5px;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.54);
}
.c-camera {
  position: absolute;
  bottom: 0px;
  right: 0px;
  z-index: 100;
}
.c-camera i {
  filter: drop-shadow(2px 2px 2px rgba(0, 0, 0, 0.6));
}
</style>
